export type WaypointStatus = 0 | 1 | 2 | 3 | 4 | 5 | 6;
export const WaypointStatus = {
    Pendiente: 0 as WaypointStatus,
    EnDireccion: 1 as WaypointStatus,
    Completado: 2 as WaypointStatus,
    Cancelado: 3 as WaypointStatus
};